export const featuresMapping = [
  { key: 'canEditPAL', label: 'Edition des PALs' },
  { key: 'canEditMasters', label: 'Édition des Masters' },
  { key: 'launchCampaign', label: 'Lancer une campagne' },
  { key: 'enabledPmlFront', label: 'Setup PML en Front' },
  {
    key: 'enabledPmlRepiquage',
    label: 'Import campagnes et créas repiquées'
  },
  {
    key: 'sendCreationEmailOnCampaignValidation',
    label: "Création d'utilisateur à la première campagne"
  },
  {
    key: 'simpleReport',
    label: 'Simplification du bilan (Vue PML Uniquement)'
  },
  {
    key: 'hideActivationObjective',
    label: 'Masquer objectif activation'
  },
  {
    key: 'removeCampagnEndPage',
    label: 'Suppression page lancement de campagne'
  },
  {
    key: 'activationAdAccountAndPages',
    label: 'Ajout comptes/pages pub dans Activation'
  },
  {
    key: 'hideFacturation',
    label: 'Masquer la section Facturation'
  },
  { key: 'skipPaymentModal', label: 'Passer la modale de paiement' },
  { key: 'groupByShopGroup', label: 'Regrouper par réseau' },
  {
    key: 'exportDataPartnerProfiles',
    label: 'Exporter les profils data partenaire'
  },
  { key: 'campaignReady', label: 'Statut campagne prête' },
  { key: 'exportSpendings', label: 'Export dépenses hors plateforme' },
  { key: 'previewLink', label: 'Générer des liens de preview' },
  {
    key: 'enableRoutableSms',
    label: 'Différencier SMS routable et SMS non routable '
  },
  {
    key: 'EditCampaigns',
    label: 'Renommer campagne depuis dashboard',
    tooltip:
      'Avec cette fonctionnalité, vous pouvez renommer les campagnes depuis le dashboard PML'
  },
  {
    key: 'duplicateModifyCampaigns',
    label: 'Dupliquer les campagnes',
    tooltip:
      'L’ajout de ce droit à votre profil vous permet d’utiliser la fonctionnalité, si elle est activée au niveau du domaine.'
  },
  {
    key: 'proposeCampaignChanges',
    label: 'Proposer des modifications',
    tooltip:
      'Permet de préparer des modifications sur une campagne en diffusion et de les marquer prêtes, sans les soumettre ni les payer. Le magasin les valide et les paie ensuite.'
  },
  {
    key: 'editCampaignInBroadcast',
    label: 'Modifier et payer une campagne en diffusion',
    tooltip:
      'Permet d’éditer les campagnes validées, actives, en pause ou terminées pendant leur diffusion, puis de soumettre et payer les modifications. Applicable uniquement sur les médias avec setup automatique : Meta Ads.'
  },

  {
    key: 'ermesAgentV2',
    label: 'Accès aux agents Ermes - poc'
  },
  {
    key: 'importAdsFromFront',
    label: 'Importer les publicités depuis le front',
    tooltip: "Ce droit permet d'ajouter des publicités en masse"
  },
  {
    key: 'editMediaBroadcastDates',
    label: 'Modifier les dates de diffusions par média'
  },
  {
    key: 'sharedMediaPlan',
    label: 'Comparer mes plans médias'
  },
  {
    key: 'archiveShops',
    label: 'Archiver / désarchiver des points de vente',
    tooltip:
      'Autorise l’archivage et le désarchivage des points de vente. Un magasin archivé est masqué de la plateforme et ses funnels sont désactivés.'
  }
];

export const simplifiedBoFeaturesMapping = [
  { key: 'customSetupEnabled', label: 'Fichier import custom LBC' },
  {
    key: 'pointOfSalesBoSimplified',
    label: 'Section Points de ventes BO simplifié'
  }
];

export const featuresMappingContent = [
  { key: 'accessContent', label: 'Accèder au Creative Builder' },
  {
    key: 'accessTemplate',
    label: 'Accèder au Template'
  }
];

export const pmlSectionMapping = [
  { key: 'inProgressSection', label: 'Section Campagnes lancées' },
  { key: 'scheduledSection', label: 'Section Campagnes programmées' },
  { key: 'palSection', label: 'Section PAL' },
  { key: 'draftsSection', label: 'Section Campagnes à finaliser' },
  { key: 'spendingsSection', label: 'Section Dépenses' },
  {
    key: 'newCampaignsSection',
    label: 'Section Création de nouvelle campagne'
  },
  {
    key: 'expiredCampaignsSection',
    label: 'Section Campagnes expirées'
  }
];

export const funnelSectionMapping = [
  { key: 'hideKpiSelect', label: 'Masquer le select de KPIs' },
  {
    key: 'hideGranularitySelect',
    label: 'Masquer le select de granularités'
  },
  {
    key: 'hideGranularityFilter',
    label: 'Masquer le filtre par granularité'
  },
  { key: 'hideExport', label: 'Masquer le bouton export' },
  { key: 'hideBarChart', label: 'Masquer le bar chart' },
  {
    key: 'hideLineChart',
    label: 'Masquer le line chart'
  }
];

export default {
  featuresMapping,
  simplifiedBoFeaturesMapping,
  featuresMappingContent,
  pmlSectionMapping,
  funnelSectionMapping
};
